import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { type } from '../../style';
import { Report } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import { CustomStyledProps } from 'style/style';

const DeclinedContainer = styled('div')<{ showTips: boolean }>(
  {
    margin: '0 auto',
    padding: '15px 10px',
    marginBottom: 20,
    border: 'solid 1px #F00',
    backgroundColor: '#F8E9EA',
    borderRadius: 6,
  },
  ({ showTips }: CustomStyledProps) =>
    showTips && {
      position: 'relative',
      paddingBottom: 40,
    }
);

const LockIconConainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});

const TipContainer = styled('div')({
  ...type.MEDIUM,
  textAlign: 'center',
  backgroundColor: '#F00',
  color: '#ffffff',
  padding: '4px 0',
  position: 'absolute',
  bottom: 0,
  left: 0,
  borderBottomLeftRadius: 6,
  borderBottomRightRadius: 6,
  width: '100%',
});

const StyledIcon = styled(Report)({
  fontSize: '34px !important',
  paddingRight: 3,
  color: '#DD0B24',
});

const CreditCardText = styled('div')({
  textAlign: 'center',
  margin: '5px 0',
  color: '#353946',
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const TitleText = styled('h4')(() => {
  const theme = useTheme();

  return {
    textAlign: 'center',
    margin: '5px 0',
    color: '#353946',
    [theme.breakpoints.down('md')]: {
      maxWidth: 250,
      margin: '5px auto',
    },
  };
});

interface IPaymentDeclined {
  showTips?: boolean;
}

const PaymentDeclined: React.FC<IPaymentDeclined> = ({ showTips = false }): ReactElement => {
  return (
    <DeclinedContainer data-test-id="cy-declined-payment" showTips={showTips}>
      <LockIconConainer>
        <StyledIcon />
      </LockIconConainer>
      <TitleText>Payment Validation Failed: Processor Declined</TitleText>
      <CreditCardText>For security reasons, please re-enter your credit card information.</CreditCardText>
      {showTips && <TipContainer>Tip: You may try another credit card</TipContainer>}
    </DeclinedContainer>
  );
};

export default PaymentDeclined;
